import EventsModule from "@pages/events/EventsModule";
import EventsIndex from "@pages/events/EventsIndex";
import RegisterEntries from "@pages/events/RegisterEntries";
import EventExhibitorsIndex from "@pages/events/EventExhibitorsIndex";

export default {
    path: '/events',
    component: EventsModule,
    children: [
        {
            path: '',
            name: 'eventsIndex',
            component: EventsIndex
        },
        {
            path: 'register-entries',
            name: 'eventsRegisterEntries',
            component: RegisterEntries,
            props: true,
        },
        {
            path: 'event-exhibitors',
            name: 'eventExhibitors',
            component: EventExhibitorsIndex,
            props: true,
        },
    ]
}
